import { Component, OnInit, Inject, Optional } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'moment';

@Component({
	selector: 'app-add-category',
	templateUrl: './add-category.component.html',
	styleUrls: ['./add-category.component.scss']
})
export class AddCategorytComponent implements OnInit {
	categoryForm: FormGroup;
	submitted = false;
	constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<AddCategorytComponent>, private formBuilder: FormBuilder) { }

	ngOnInit() {
		this.categoryForm = this.formBuilder.group({
			categoryName: ['', Validators.required],
			categoryId: ['', Validators.required],
			active: ['', Validators.required],
			productAdded: moment().unix()
		}, {
		});
	}

	// convenience getter for easy access to form fields
	get f() { return this.categoryForm.controls; }

	onSubmit() {
		this.submitted = true;

		// stop here if form is invalid
		if (this.categoryForm.invalid) {
			return;
		}
		this.dialogRef.close(this.categoryForm.value);
	}

	onReset() {
		this.submitted = false;
		this.categoryForm.reset();
	}
}
